<template>
  <div class="col-sm-12">
    <div class="mt-2">
      <div class="row pl-3 pr-3">
        <div class="col-md-6 mt-4-custom">
          <input
            type="text"
            placeholder="Search ..."
            v-model="searchQueryTraining"
            class="search_button ques-search form-control form-control-sm"
          />
        </div>
        <div class="col-md-6">
          <label for="FilterbyThematicArea">
            <b>Filter by Thematic Area</b>
          </label>
          <selectize
            id="select-state"
            class="text-capitalize form-control-md"
            v-model="thematicArea"
            :settings="departmentSetting"
            :searchable="true"
          >
            <option value="-1">All</option>
            <option
              v-for="(item, index) in thematicAreaArr"
              :key="index"
              :value="item.id"
              class="text-capitalize"
            >{{ item.name }}</option>
          </selectize>
        </div>
      </div>

      <br />
      <b-card no-body style="border:none !important;">
        <b-tabs pills card vertical>
          <b-tab :title-item-class="'tab-title-class'" disabled title="Filter by" style></b-tab>
          <div>
            <b-tab title="All" :active="tfilter === true">
              <b-card-text
                v-for="(tquestion, optionsCounter) in thematicQuestions"
                :key="optionsCounter"
              >
                <div class="col-md-12">
                  <div class="tab-item">
                    <h6 class="tab-item__heading mb-1">
                      <b>Q )</b>
                      {{ tquestion.title }} ?
                    </h6>
                    <div
                      v-for="(toptions, index) in thematicQuestionsOptions"
                      :key="index"
                      class="option_type"
                    >
                      <template>
                        <div v-for="(ttopt, optindex) in toptions" :key="optindex">
                          <div
                            v-if="ttopt.questionBank_id == tquestion.id"
                            class="inner_options_dev"
                            :class="{ correct: ttopt.status == 1 }"
                          >{{ ttopt.title }}</div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </b-card-text>
            </b-tab>
          </div>

          <b-tab title="Assessment" @click="changeActive()">
            <b-card-text v-for="(feedback, optionsCounter) in questionFilter" :key="optionsCounter">
              <div class="col-md-12" v-if="feedback.category && feedback.category == '1'">
                <div class="tab-item">
                  <h6 class="tab-item__heading mb-1">
                    <b>Q )</b>
                    {{ feedback.title }} ?
                  </h6>
                  <div
                    v-for="(options, index) in feedbackQuestionOptions"
                    :key="index"
                    class="option_type"
                  >
                    <template>
                      <div v-for="(opt, optindex) in options" :key="optindex">
                        <div
                          v-if="opt.questionBank_id == feedback.id"
                          class="inner_options_dev"
                          :class="{ correct: opt.status == 1 }"
                        >{{ opt.title }}</div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </b-card-text>
          </b-tab>
          <b-tab title="Trainer's Feedback" @click="changeActive()">
            <b-card-text v-for="(feedback, optionsCounter) in questionFilter" :key="optionsCounter">
              <div class="col-md-12" v-if="feedback.category && feedback.category == '2'">
                <div class="tab-item">
                  <h6 class="tab-item__heading mb-1">
                    <b>Q )</b>
                    {{ feedback.title }} ?
                  </h6>
                  <div
                    v-for="(options, index) in feedbackQuestionOptions"
                    :key="index"
                    class="option_type"
                  >
                    <template>
                      <div v-for="(opt, optindex) in options" :key="optindex">
                        <div
                          v-if="opt.questionBank_id == feedback.id"
                          class="inner_options_dev"
                        >{{ opt.title }}</div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </b-card-text>
          </b-tab>
          <b-tab title="Trainee's Feedback" @click="changeActive()">
            <b-card-text v-for="(feedback, optionsCounter) in questionFilter" :key="optionsCounter">
              <div class="col-md-12" v-if="feedback.category && feedback.category == '3'">
                <div class="tab-item">
                  <h6 class="tab-item__heading mb-1">
                    <b>Q )</b>
                    {{ feedback.title }} ?
                  </h6>
                  <div
                    v-for="(options, index) in feedbackQuestionOptions"
                    :key="index"
                    class="option_type"
                  >
                    <template>
                      <div v-for="(kptOptions, kptindex) in options" :key="kptindex">
                        <div
                          v-if="kptOptions.questionBank_id == feedback.id"
                          class="inner_options_dev"
                        >{{ kptOptions.title }}</div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </b-card-text>
          </b-tab>

          <hr />
          <b-tab disabled title="Filter by Level" @click="changeActive()"></b-tab>
          <b-tab title="Basic" @click="changeActive()">
            <b-card-text v-for="(feedback, optionsCounter) in questionFilter" :key="optionsCounter">
              <div class="col-md-12" v-if="feedback.level && feedback.level == '6'">
                <div class="tab-item">
                  <h6 class="tab-item__heading mb-1">
                    <b>Q )</b>
                    {{ feedback.title }} ?
                  </h6>
                  <div
                    v-for="(options, index) in feedbackQuestionOptions"
                    :key="index"
                    class="option_type"
                  >
                    <template>
                      <div v-for="(ywoptions, ywindex) in options" :key="ywindex">
                        <div
                          v-if="ywoptions.questionBank_id == feedback.id"
                          class="inner_options_dev"
                          :class="{ correct: ywoptions.status == 1 }"
                        >{{ ywoptions.title }}</div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </b-card-text>
          </b-tab>
          <b-tab title="Intermediate" @click="changeActive()">
            <b-card-text v-for="(feedback, optionsCounter) in questionFilter" :key="optionsCounter">
              <div class="col-md-12" v-if="feedback.level && feedback.level == '7'">
                <div class="tab-item">
                  <h6 class="tab-item__heading mb-1">
                    <b>Q )</b>
                    {{ feedback.title }} ?
                  </h6>
                  <div
                    v-for="(options, index) in feedbackQuestionOptions"
                    :key="index"
                    class="option_type"
                  >
                    <template>
                      <div v-for="(kdOptions, Kdindex) in options" :key="Kdindex">
                        <div
                          v-if="kdOptions.questionBank_id == feedback.id"
                          class="inner_options_dev"
                          :class="{ correct: kdOptions.status == 1 }"
                        >{{ kdOptions.title }}</div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </b-card-text>
          </b-tab>
          <b-tab title="Advanced" @click="changeActive()">
            <b-card-text v-for="(feedback, optionsCounter) in questionFilter" :key="optionsCounter">
              <div class="col-md-12" v-if="feedback.level && feedback.level == '8'">
                <div class="tab-item">
                  <h6 class="tab-item__heading mb-1">
                    <b>Q )</b>
                    {{ feedback.title }} ?
                  </h6>
                  <div
                    v-for="(options, index) in feedbackQuestionOptions"
                    :key="index"
                    class="option_type"
                  >
                    <template>
                      <div v-for="(ppoptions, ppindex) in options" :key="ppindex">
                        <div
                          v-if="ppoptions.questionBank_id == feedback.id"
                          class="inner_options_dev"
                          :class="{ correct: ppoptions.status == 1 }"
                        >{{ ppoptions.title }}</div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Selectize from "vue2-selectize";
export default {
  data: () => ({
    feedbackQuestions: [],
    feedbackQuestionOptions: [],
    thematicAreaArr: [],
    searchQueryTraining: "",
    thematicQuestionsOptions: [],
    thematicQuestions: [],
    thematicArea: [],
    tfilter: false,
    thematicFilter: [],
    departmentSetting: {
      maxItems: 1,
      searchField: ["title"],
      plugins: ["remove_button"],
      placeholder: "Select Thematic area"
    },
    isSidebar: false
  }),
  mounted() {
    this.AllQuestions();

    axios
      .get(localStorage.getItem("BASE_PATH") + "/show/thematicArea/get",{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.thematicAreaArr = response.data;
      });
  },
  components: {
    Selectize
  },
  watch: {
    thematicArea(val) {
      this.tfilter = true;
      if (val && val == -1) {
         this.AllQuestions();
      } else {
        this.openLoading();
        axios
          .get(
            localStorage.getItem("BASE_PATH") +
              "/show/thematic/filter/question/" +
              val,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
            this.closeLoading();
            
            this.thematicQuestions = response.data.questionArray;
            this.thematicQuestionsOptions = response.data.optionArray;
          });
      }
    }
  },
  methods: {
    AllQuestions: function AllQuestions() {
      this.openLoading();
      axios
        .get(localStorage.getItem("BASE_PATH") + "/ques_bank/get",{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.feedbackQuestions = response.data["questionArray"];
          this.feedbackQuestionOptions = response.data.optionArray;
          this.thematicQuestions = this.feedbackQuestions;
          this.thematicQuestionsOptions = this.feedbackQuestionOptions;
        });
    },
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    changeActive() {
      this.tfilter = false;
    },
    closeLoading() {
      this.$vs.loading.close();
    }
  },
  computed: {
    questionFilter: function() {
      return this.feedbackQuestions.filter(items => {
        for (var item in items) {
          //console.log(items.training);
          if (String(items[item]).toLowerCase().indexOf(this.searchQueryTraining.toLowerCase()) !== -1) {
            return true;
          }
        }
        return false;
      });
    }
  }
};
</script>

<style>
.nav-link.disabled {
  font-weight: bold !important;
  font-size: 15px !important;
  color: #6c757d;
  pointer-events: none;
  cursor: default;
}
</style>

<style scoped>
#menu-toggle {
  display: none;
}

.card-body {
  padding: 0px !important;
}

.tab-item {
  background: white;
  border: 1px #d5dadf solid;
  border-left: 1px solid #d5dadf;
  box-shadow: 0 2px 3px rgba(213, 218, 223, 0.35);
  padding: 15px;
  border-radius: 3px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 15px;
}

.tab-item:hover,
.tab-item.active {
  box-shadow: 0px 3px 3px 2px rgba(213, 218, 223, 0.35);
  border-left: 1px solid #009ad2;
}

.tab-item__heading {
  font-weight: bold;
  font-size: 18px;
  line-height: 1.3em;
  letter-spacing: 0.02em;
  color: #6c757d;
  margin: 0px;
}

.tab-item__subheading {
  font-size: 15px;
  color: #6c757d;
  margin: 0px;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}

.correct {
  color: green;
  font-weight: bold;
}
.ques-search {
  height: 34px !important;
}
.mt-4-custom {
  margin-top: 27px;
}
</style>
